import { gql } from '@apollo/client';

export const fetchAvailablePartnerPromotionsForChangeEntitlementPPC = gql`
  query fetchAvailablePartnerPromotionsForChangeEntitlementPPC(
    $id: String
    $intendedBillingPeriodState: String
    $transactionAccountId: String
    $billingFrequency: String
    $discountTier: String
    $programLevelGlobal: String
  ) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      id
      subscriptionId
      billingFrequency: billingCycle
      productId
      edition
      availablePromotions: availablePartnerPromotions(
        intendedBillingPeriodState: $intendedBillingPeriodState
        billingFrequency: $billingFrequency
        discountTier: $discountTier
        programLevelGlobal: $programLevelGlobal
      ) {
        id
        title
        benefits {
          benefitType
          duration
          subBenefitType
          iterations
          value
          scale
          type
          customisable {
            value {
              type
              lowerBound
              upperBound
            }
            iterations {
              type
              lowerBound
              upperBound
            }
            duration
          }
        }
        promotionWindow {
          endTime
          startTime
        }
        status
        cycleInterval
        pricingType
        eligibilityRules {
          products
          cycleInterval
          pricingType
          partnerType
          partnerTier
          saleTransitionType
          currency
        }
        applicationReason {
          id
          readableName
          customisable {
            id {
              type
              anyOf {
                readableName
                id
              }
            }
          }
        }
        customisableReasons {
          readableName
          id
        }
        isPromotionCustomisable
        type
      }
    }
  }
`;
